/* AdvisoryCriticalityRenderer.js */

"use strict";

const _ = require("lodash");

class AdvisoryCriticalityRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("advisory-criticality-column");
        this._rootElem.component = this._model;

        this._viewDetailsIcon = document.createElement("actionable-icon-gl");
        this._viewDetailsIcon.dataset.icon = "common.warning";
        this._rootElem.appendChild(this._viewDetailsIcon);

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._viewDetailsIcon.remove();
            this._viewDetailsIcon = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("AdvisoryCriticality", (this._onAdvisoryColumn = this._onAdvisoryColumn.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("AdvisoryCriticality");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setAdvisoryColumn(this._model._value);
            this._setForAttribute(this._model._value.toLowerCase());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onAdvisoryColumn(newVal) {
        this._setAdvisoryColumn(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setAdvisoryColumn(newVal) {
        if (!_.isUndefined(newVal)) {
            this._rootElem.innerHTML += newVal;
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    _setForAttribute(newVal) {
        if (!_.isUndefined(newVal)) {
            this._rootElem.setAttribute("for", newVal);
        } else {
            this._rootElem.setAttribute("for", "");
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = AdvisoryCriticalityRenderer;
